<!-- Основные параметры расхода: категория, сумма, время и плательщик. -->
<template>
  <BaseFormSection title="Расход" icon="info">
    <BaseFormField
      label="Категория"
      for-id="category"
      required
      :filled="isFieldFilled('expense_category_id')"
      :error="errors.expense_category_id"
    >
      <ExpenseCategorySelect
        id="category"
        :model-value="expense.expense_category_id"
        placeholder="Выберите категорию"
        :clearable="false"
        :invalid="errors.expense_category_id"
        @change="handleCategoryChange"
        @update:model-value="
          handleFieldChange('expense_category_id', $event)
        "
      />
    </BaseFormField>

    <BaseFormField
      label="Сумма"
      for-id="amount"
      required
      :filled="isFieldFilled('amount')"
      :error="errors.amount"
    >
      <base-input
        id="amount"
        :model-value="expense.amount"
        type="big_number"
        step="any"
        min="0"
        :invalid="errors.amount"
        @update:model-value="handleFieldChange('amount', $event)"
      />
    </BaseFormField>

    <BaseFormField
      v-if="showLitersField"
      label="Литры"
      for-id="liters"
      :filled="isFieldFilled('liters')"
    >
      <base-input
        id="liters"
        :model-value="expense.liters"
        type="number"
        step="0.01"
        min="0"
        placeholder="Количество литров"
        @update:model-value="handleFieldChange('liters', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Время траты"
      for-id="spent_at"
      :filled="isFieldFilled('spent_at')"
    >
      <base-input
        id="spent_at"
        :model-value="expense.spent_at"
        type="datetime-local"
        class="form-input"
        @update:model-value="handleFieldChange('spent_at', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Кто потратил"
      for-id="spender"
      :filled="isFieldFilled('spender_id')"
    >
      <CompanyUserSelect
        id="spender"
        :model-value="expense.spender_id"
        placeholder="Выберите пользователя"
        @update:model-value="handleFieldChange('spender_id', $event)"
      />
    </BaseFormField>
  </BaseFormSection>
</template>

<script>
import CompanyUserSelect from "@/components/CompanyUser/CompanyUserSelect.vue";
import ExpenseCategorySelect from "@/components/Expense/ExpenseCategorySelect.vue";

export default {
  name: "ExpenseMainSection",

  components: {
    CompanyUserSelect,
    ExpenseCategorySelect,
  },

  props: {
    errors: { type: Object, required: true },
    expense: { type: Object, required: true },
    showLitersField: { type: Boolean, required: true },
  },

  emits: ["category-change", "clear-error", "update-field"],

  methods: {
    handleFieldChange(field, value) {
      this.$emit("update-field", field, value);
      this.$emit("clear-error", field);
    },

    handleCategoryChange(categoryId) {
      this.$emit("category-change", categoryId);
    },

    isFieldFilled(field) {
      const value = this.expense[field];
      return value !== null && value !== undefined && value !== "";
    },
  },
};
</script>
